import { ColorModeScript } from "@chakra-ui/react";
import * as React from "react";
import * as ReactDOM from "react-dom/client";
import { App } from "./App";
import { isGuidePath } from "./guides/routes";
import reportWebVitals from "./reportWebVitals";
import * as serviceWorker from "./serviceWorker";

const GuideApp = React.lazy(() =>
  import("./guides/GuideApp").then((module) => ({ default: module.GuideApp })),
);

const container = document.getElementById("root");
if (!container) throw new Error("Failed to find the root element");
const root = ReactDOM.createRoot(container);

if (window.location.hostname === "short.ifmage.xyz") {
  const redirectUrl = new URL(window.location.href);
  redirectUrl.protocol = "https:";
  redirectUrl.hostname = "create-link.weplet.com";
  redirectUrl.port = "";
  window.location.replace(redirectUrl.toString());
} else if (window.location.hostname === "i.weplet.com") {
  const redirectUrl = new URL(window.location.href);
  redirectUrl.hostname = "link.weplet.com";
  window.location.replace(redirectUrl.toString());
} else if (
  window.location.hostname === "link.weplet.com" &&
  window.location.pathname === "/"
) {
  window.location.replace("https://create-link.weplet.com/");
} else {
  root.render(
    <React.StrictMode>
      <ColorModeScript />
      {isGuidePath(window.location.pathname) ? (
        <React.Suspense
          fallback={
            <div className="guide-loading" role="status">
              사용 가이드를 불러오는 중입니다.
            </div>
          }
        >
          <GuideApp />
        </React.Suspense>
      ) : (
        <App />
      )}
    </React.StrictMode>
  );
}

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorker.unregister();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
